export default {
  'app.settings.menuMap.basic': 'Configuración básica',
  'app.settings.menuMap.security': 'Configuración de seguridad',
  'app.settings.menuMap.binding': 'Vinculación de cuenta',
  'app.settings.menuMap.notification': 'Notificación de nuevos mensajes',
  'app.settings.basic.avatar': 'Avatar',
  'app.settings.basic.change-avatar': 'Cambiar avatar',
  'app.settings.basic.email': 'Correo electrónico',
  'app.settings.basic.email-message': '¡Por favor, introduce tu correo electrónico!',
  'app.settings.basic.nickname': 'Apodo',
  'app.settings.basic.nickname-message': '¡Por favor, introduce tu apodo!',
  'app.settings.basic.profile': 'Perfil personal',
  'app.settings.basic.profile-message': '¡Por favor, introduce tu perfil personal!',
  'app.settings.basic.profile-placeholder': 'Breve presentación sobre ti',
  'app.settings.basic.country': 'País/Región',
  'app.settings.basic.country-message': '¡Por favor, introduce tu país!',
  'app.settings.basic.geographic': 'Provincia o ciudad',
  'app.settings.basic.geographic-message': '¡Por favor, introduce tu información geográfica!',
  'app.settings.basic.address': 'Dirección',
  'app.settings.basic.address-message': '¡Por favor, introduce tu dirección!',
  'app.settings.basic.phone': 'Número de teléfono',
  'app.settings.basic.phone-message': '¡Por favor, introduce tu teléfono!',
  'app.settings.basic.update': 'Actualizar información',
  'app.settings.security.strong': 'Fuerte',
  'app.settings.security.medium': 'Media',
  'app.settings.security.weak': 'Débil',
  'app.settings.security.password': 'Contraseña de la cuenta',
  'app.settings.security.password-description': 'Fortaleza de la contraseña actual',
  'app.settings.security.phone': 'Teléfono de seguridad',
  'app.settings.security.phone-description': 'Teléfono vinculado',
  'app.settings.security.question': 'Pregunta de seguridad',
  'app.settings.security.question-description':
    'La pregunta de seguridad no está configurada, y la política de seguridad puede proteger eficazmente la cuenta',
  'app.settings.security.email': 'Correo de respaldo',
  'app.settings.security.email-description': 'Correo vinculado',
  'app.settings.security.mfa': 'Dispositivo MFA',
  'app.settings.security.mfa-description':
    'Dispositivo MFA no vinculado; tras vincularlo, se podrá confirmar dos veces',
  'app.settings.security.modify': 'Modificar',
  'app.settings.security.set': 'Establecer',
  'app.settings.security.bind': 'Vincular',
  'app.settings.binding.taobao': 'Vincular Taobao',
  'app.settings.binding.taobao-description': 'Cuenta de Taobao no vinculada',
  'app.settings.binding.alipay': 'Vincular Alipay',
  'app.settings.binding.alipay-description': 'Cuenta de Alipay no vinculada',
  'app.settings.binding.dingding': 'Vincular DingTalk',
  'app.settings.binding.dingding-description':
    'Cuenta de DingTalk no vinculada',
  'app.settings.binding.bind': 'Vincular',
  'app.settings.notification.password': 'Contraseña de la cuenta',
  'app.settings.notification.password-description':
    'Los mensajes de otros usuarios se notificarán en forma de mensaje interno',
  'app.settings.notification.messages': 'Mensajes del sistema',
  'app.settings.notification.messages-description':
    'Los mensajes del sistema se notificarán en forma de mensaje interno',
  'app.settings.notification.todo': 'Notificación de tareas',
  'app.settings.notification.todo-description':
    'La lista de tareas se notificará en forma de mensaje interno',
  'app.settings.open': 'Abrir',
  'app.settings.close': 'Cerrar',
};